module.exports = __webpack_public_path__ + "static/media/icon-logo.52a0ed9e.svg";